/* eslint-disable */
import { createStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      flex: 1,
      marginBottom: 50,
      marginTop: 64,
      "& svg": {
        marginBottom: theme.spacing(4),
      },
    },
    header: {
      textAlign: "center",
      maxWidth: "50%",
      fontSize: "25px",
      fontWeight: "bold",
    },
    link: {
      textDecorationColor: "#004a96",
      color: "#004a96",
    },
  });
